module.exports = __webpack_public_path__ + "img/using_character_creater_trigger.97d6bb02.jpg";